export type PeopleTab = 'active' | 'events' | 'offboarded'

/**
 * Whether the People directory's team/manager filter options should be
 * narrowed to currently active teams and managers (TASK-308). The Active and
 * Events tabs list only currently active people, so a team with no active
 * member or a departed manager would be a filter that can never match. The
 * Offboarded tab lists departed people, so it keeps every team and manager.
 */
export const peopleFilterRefsCurrentlyActive = (tab: PeopleTab): boolean => tab !== 'offboarded'
